webpackJsonp([128747004913641],{

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _salesModule = __webpack_require__(254);
	
	var _salesModule2 = _interopRequireDefault(_salesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignupPage = function (_Component) {
	  _inherits(SignupPage, _Component);
	
	  function SignupPage(props) {
	    _classCallCheck(this, SignupPage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleUserInput = function (e) {
	      var _this$setState;
	
	      var name = e.target.name;
	      var value = e.target.value;
	      _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState), function () {
	        _this.validateField(name, value);
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.setState({ loading: true });
	      var scriptUrl = 'https://script.google.com/macros/s/AKfycbwNTja2BfmVbYc_IM5cNQ2sXkkBagnISt9dAAGDe1Op94qYaT0/exec';
	      var url = scriptUrl + '?name=' + _this.state.name + '&email=' + _this.state.email + '&comments=' + _this.state.comments + '&company=' + _this.state.company + '&job_title=' + _this.state.job_title + '&phone=' + _this.state.phone;
	      var form_data = {
	        name: _this.state.name,
	        email: _this.state.email,
	        company: _this.state.company,
	        job_title: _this.state.job_title,
	        phone: _this.state.phone,
	        comments: _this.state.comments
	      };
	
	      fetch(url, {
	        method: "GET",
	        mode: "no-cors",
	        dataType: "json"
	      }).then(function (responseJson) {
	        _this.setState({ loading: false });
	        alert("Thanks for contacting us. Our sales team shall get back to you shortly");
	        _this.setState({
	          name: '',
	          email: '',
	          company: '',
	          job_title: '',
	          phone: '',
	          comments: '',
	          nameValid: false,
	          emailValid: false,
	          companyValid: false,
	          job_titleValid: false,
	          phoneValid: false,
	          commentsValid: false,
	          formErrors: { name: '', email: '', company: '', job_title: '', phone: '', comments: '' },
	          formValid: false,
	          loading: false
	        });
	      }).catch(function (error) {
	        _this.setState({ loading: false });
	        console.error(error);
	      });
	    };
	
	    _this.state = {
	      name: '',
	      email: '',
	      company: '',
	      job_title: '',
	      phone: '',
	      comments: '',
	      nameValid: false,
	      emailValid: false,
	      companyValid: false,
	      job_titleValid: false,
	      phoneValid: false,
	      commentsValid: false,
	      formErrors: { name: '', email: '', company: '', job_title: '', phone: '', comments: '' },
	      formValid: false,
	      loading: false
	    };
	    return _this;
	  }
	
	  SignupPage.prototype.validateField = function validateField(fieldName, value) {
	    var fieldValidationErrors = this.state.formErrors;
	    var nameValid = this.state.nameValid;
	    var emailValid = this.state.emailValid;
	    var companyValid = this.state.companyValid;
	    var job_titleValid = this.state.job_titleValid;
	    var phoneValid = this.state.phoneValid;
	    var commentsValid = this.state.commentsValid;
	    switch (fieldName) {
	      case 'email':
	        value = value.trim();
	        if (value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) emailValid = true;
	        fieldValidationErrors.email = emailValid ? '' : 'Please provide a valid email';
	        break;
	      case 'phone':
	        value = value.trim();
	        phoneValid = value.length >= 5;
	        fieldValidationErrors.phone = phoneValid ? '' : 'Phone number is too short';
	        break;
	      case 'name':
	        value = value.trim();
	        nameValid = value.length >= 1;
	        fieldValidationErrors.name = nameValid ? '' : 'Please provide your name';
	        break;
	      case 'company':
	        value = value.trim();
	        companyValid = value.length >= 1;
	        fieldValidationErrors.company = companyValid ? '' : 'Please provide your company name';
	        break;
	      default:
	        break;
	    }
	    this.setState({ formErrors: fieldValidationErrors,
	      nameValid: nameValid,
	      emailValid: emailValid,
	      companyValid: companyValid,
	      job_titleValid: job_titleValid,
	      phoneValid: phoneValid,
	      commentsValid: commentsValid
	    }, this.validateForm);
	  };
	
	  SignupPage.prototype.validateForm = function validateForm() {
	    this.setState({ formValid: this.state.nameValid && this.state.phoneValid && this.state.companyValid && this.state.emailValid });
	  };
	
	  SignupPage.prototype.render = function render() {
	    var formErrors = this.state.formErrors;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _salesModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _salesModule2.default.form__panel },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit, 'data-netlify': 'true' },
	          _react2.default.createElement(
	            'div',
	            { className: _salesModule2.default.form__input__group },
	            _react2.default.createElement(
	              'div',
	              { className: _salesModule2.default.form__input__unit },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Name',
	                _react2.default.createElement(
	                  'span',
	                  { className: _salesModule2.default.required__field },
	                  '*'
	                )
	              ),
	              _react2.default.createElement('input', { type: 'text', name: 'name', value: this.state.name, onChange: this.handleUserInput }),
	              formErrors.name != '' && _react2.default.createElement(
	                'div',
	                { className: _salesModule2.default.form_errors },
	                formErrors.name
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _salesModule2.default.form__input__group },
	            _react2.default.createElement(
	              'div',
	              { className: _salesModule2.default.form__input__unit },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Email',
	                _react2.default.createElement(
	                  'span',
	                  { className: _salesModule2.default.required__field },
	                  '*'
	                )
	              ),
	              _react2.default.createElement('input', { type: 'text', name: 'email', value: this.state.email, onChange: this.handleUserInput, size: '50' }),
	              formErrors.email != '' && _react2.default.createElement(
	                'div',
	                { className: _salesModule2.default.form_errors },
	                formErrors.email
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _salesModule2.default.form__input__group },
	            _react2.default.createElement(
	              'div',
	              { className: _salesModule2.default.form__input__unit },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Company',
	                _react2.default.createElement(
	                  'span',
	                  { className: _salesModule2.default.required__field },
	                  '*'
	                )
	              ),
	              _react2.default.createElement('input', { type: 'text', name: 'company', value: this.state.company, onChange: this.handleUserInput, size: '50' }),
	              formErrors.company != '' && _react2.default.createElement(
	                'div',
	                { className: _salesModule2.default.form_errors },
	                formErrors.company
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _salesModule2.default.form__input__group },
	            _react2.default.createElement(
	              'div',
	              { className: _salesModule2.default.form__input__unit },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Job Title'
	              ),
	              _react2.default.createElement('input', { type: 'text', name: 'job_title', value: this.state.job_title, onChange: this.handleUserInput, size: '50' }),
	              formErrors.job_title != '' && _react2.default.createElement(
	                'div',
	                { className: _salesModule2.default.form_errors },
	                formErrors.job_title
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _salesModule2.default.form__input__group },
	            _react2.default.createElement(
	              'div',
	              { className: _salesModule2.default.form__input__unit },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Phone',
	                _react2.default.createElement(
	                  'span',
	                  { className: _salesModule2.default.required__field },
	                  '*'
	                )
	              ),
	              _react2.default.createElement('input', { type: 'tel', name: 'phone', value: this.state.phone, onChange: this.handleUserInput, size: '50' }),
	              formErrors.phone != '' && _react2.default.createElement(
	                'div',
	                { className: _salesModule2.default.form_errors },
	                formErrors.phone
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _salesModule2.default.form__input__group },
	            _react2.default.createElement(
	              'div',
	              { className: _salesModule2.default.form__input__unit },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Comments'
	              ),
	              _react2.default.createElement('textarea', { type: 'text', name: 'comments', value: this.state.comments, onChange: this.handleUserInput, size: '50', rows: '4' }),
	              formErrors.comments != '' && _react2.default.createElement(
	                'div',
	                { className: _salesModule2.default.form_errors },
	                formErrors.comments
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', disabled: !this.state.formValid, className: this.state.formValid ? _salesModule2.default.landing__btn : _salesModule2.default.landing__btn_disabled },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.state.loading ? "Submitting..." : "Submit"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return SignupPage;
	}(_react.Component);
	
	exports.default = SignupPage;
	module.exports = exports['default'];

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-pages----sales-module---container---2gOZm","form__panel":"src-pages----sales-module---form__panel---MOXdq","form__input__group":"src-pages----sales-module---form__input__group---3P2dV","form__input__unit":"src-pages----sales-module---form__input__unit---2MEKl","select":"src-pages----sales-module---select---3XyXY","landing":"src-pages----sales-module---landing---yTXbI","landing__header":"src-pages----sales-module---landing__header---2CQ41","btn__wrapper":"src-pages----sales-module---btn__wrapper---1ThWN","form_errors":"src-pages----sales-module---form_errors---5ZTK5","required__field":"src-pages----sales-module---required__field---OfE9d","landing__btn":"src-pages----sales-module---landing__btn---2y1W6","landing__btn_disabled":"src-pages----sales-module---landing__btn_disabled---KphUC","landing__btn--alt":"src-pages----sales-module---landing__btn--alt---3btX_ src-pages----sales-module---landing__btn---2y1W6"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sales-js-654df9c8521934309b03.js